import { createSelector } from 'reselect';

const selectBlogPosts = (state: any) => state.blogPosts;


export const selectBlogPostsCurrentItem = createSelector([selectBlogPosts], (blogPosts) => blogPosts.current);

export const selectBlogPostsListItems = createSelector([selectBlogPosts], (blogPosts) => blogPosts.list);

export const selectBlogPostsItemById = (itemId: any) =>
    createSelector(selectBlogPostsListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectBlogPostsQueryItem = createSelector([selectBlogPosts], (blogPosts) => blogPosts.query);

export const selectBlogPostsCreatedItem = createSelector([selectBlogPosts], (blogPosts) => blogPosts.create);

export const selectBlogPostsUpdatedItem = createSelector([selectBlogPosts], (blogPosts) => blogPosts.update);

export const selectBlogPostsReadItem = createSelector([selectBlogPosts], (blogPosts) => blogPosts.read);

export const selectBlogPostsDeletedItem = createSelector([selectBlogPosts], (blogPosts) => blogPosts.delete);

export const selectBlogPostsSearchedItems = createSelector([selectBlogPosts], (blogPosts) => blogPosts.search);

export const selectBlogPostsItemsCount = createSelector([selectBlogPosts], (blogPosts) => blogPosts.count);

export const selectBlogPostsItemsFilter = createSelector([selectBlogPosts], (blogPosts) => blogPosts.filter);